/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';

/**
 * `RestoreResult` type.
 */

export type RestoreResult = {
  migrations: string[];
  output: string;
};

/**
 * Restore the database from a SQL dump file. The API runs the migrations the
 * dump is missing right after importing it.
 */

function restore(client: AxiosInstance, file: File): Promise<RestoreResult> {
  const formData = new FormData();

  formData.append('file', file);

  return client.post(resolveAppUrl('restore'), formData).then(({ data }) => data);
}

/**
 * Export `useRestore`.
 */

export function useRestore() {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: (file: File) => restore(client, file)
  });
}
